var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36133 12.1605C6.36133 7.55129 10.0978 3.81481 14.7068 3.81481C19.3161 3.81481 23.0526 7.55129 23.0526 12.1605C23.0526 16.7697 19.3161 20.5064 14.7068 20.5064C10.0978 20.5064 6.36133 16.7697 6.36133 12.1605Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7547 11.9962C19.7514 9.859 18.4155 8.03627 16.5331 7.31442V16.6776C18.4155 15.9548 19.7514 14.1338 19.7547 11.9962ZM12.9421 16.6758V7.3154C11.0613 8.0395 9.7275 9.85961 9.72247 11.9963C9.7275 14.1323 11.0613 15.9523 12.9421 16.6758ZM14.7385 4.08212C10.3679 4.0838 6.82688 7.62554 6.82613 11.9962C6.82688 16.3663 10.3679 19.9075 14.7385 19.9082C19.1092 19.9075 22.6509 16.3663 22.6521 11.9962C22.6509 7.62554 19.1092 4.0838 14.7385 4.08212ZM14.7191 20.6551C9.93643 20.6779 6 16.8032 6 12.0865C6 6.93169 9.93643 3.36626 14.7191 3.36719H16.9604C21.6866 3.36626 26 6.93001 26 12.0865C26 16.8015 21.6866 20.6551 16.9604 20.6551H14.7191Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.fe2a8cd11b7bcc8fb4894cd1c966526e.svg";
export { ForwardRef as ReactComponent };